import { render, staticRenderFns } from "./CommodityHistoryModal.vue?vue&type=template&id=06cd857d"
import script from "./CommodityHistoryModal.vue?vue&type=script&lang=js"
export * from "./CommodityHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports